import { Component, Input } from '@angular/core';
import { ImageService } from '../../core/services/image.service';
import { HybridToolsService } from '../../core/services/hybrid-tools.service';

@Component({
    selector: 'app-team-member',
    templateUrl: './team-member.component.html',
    styleUrls: ['./team-member.component.scss']
})
export class TeamMemberComponent {
    @Input() member: any;
    @Input() isWidgetVisible: boolean;
    showingDetails: boolean = false;

    constructor(
        public imageService: ImageService,
        public hybridToolsService: HybridToolsService
    ) {
    }
}

